import React, { useState, useEffect, useMemo } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ClientComboBox from '../combobox/client-combo-box';
import API from '../../services/ApiInstance';
import apiRoutes from '../../services/ApiRoutes';
import ValidationService from '../../services/authentication/ValidationService';
import InfoDialog from '../dialog/InfoDialog';
import { toast } from 'react-toastify';

const VALIDATION_ERROR_TEXT =
  'The form could not be submitted - please fill all the required fields.';

const UserPersonalDetails = () => {
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [primOrg, setPrimOrg] = useState(null);
  const [errorDialog, setErrorDialog] = useState(false);

  const validator = useMemo(() => new ValidationService(), []);

  useEffect(() => {
    API.post(apiRoutes.userPersonalDetails).then((response) => {
      const { email: e, username: u, roleName, primaryOrganisation } = response;
      setUsername(u);
      setRole(roleName);
      setEmail(e || '');
      setPrimOrg(primaryOrganisation);
    });
  }, []);

  const handleSubmit = () => {
    const payload = { username, email, primaryOrganisation: primOrg };
    const isValid = validator.validate(
      ValidationService.validators.required(email),
      ValidationService.validators.email(email),
      ValidationService.validators.required(primOrg)
    );

    if (isValid) {
      API.post(apiRoutes.updateUserSelf, payload).then(() => {
        toast.success('Updated successfully');
      });
    } else {
      setErrorDialog(true);
    }
  };

  const emailError =
    !!email && !validator.validate(ValidationService.validators.email(email));

  return (
    <div className="page-container">
      <h1 className="page-header">Profile</h1>
      <div className="page-card" style={{ maxWidth: 520, padding: 32 }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Name</div>
          <div style={{ fontSize: 16, fontWeight: 500, color: 'var(--color-text-primary)' }}>{username}</div>
        </div>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Role</div>
          <div style={{ fontSize: 16, fontWeight: 500, color: 'var(--color-text-primary)' }}>{role}</div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <ClientComboBox
            value={primOrg}
            onChange={(e, val) => setPrimOrg(val)}
            customLabel="Primary organisation *"
          />
        </div>

        <TextField
          required
          error={emailError}
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          value={email}
          fullWidth
          variant="outlined"
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: 24 }}
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ borderRadius: 8, fontWeight: 600, padding: '10px 0' }}
        >
          Save Changes
        </Button>
      </div>
      {errorDialog && (
        <InfoDialog
          open={errorDialog}
          onClose={() => setErrorDialog(false)}
          text={VALIDATION_ERROR_TEXT}
        />
      )}
    </div>
  );
};

export default UserPersonalDetails;
